import { MeasureType, PlatformTypeEnum } from '@/common/constants';
import useStore from '@/lib/store';
import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLoadStore } from '../../store';
import { AnalysisWrapper } from '../analysis';
import { AnalysisGrainWrapper } from '../analysis-grain';
import { GeneralData } from '../general';
import { GeneralGrainData } from '../general-grain';
import { GeneralHeading } from '../heading/Heading';
import { ResidueData } from '../residue/ResidueData';

export const SingleWrapper: FC = () => {
  const { id } = useParams();
  const { user } = useStore();
  const isCotton = PlatformTypeEnum.COTTON === user?.platform_type;
  const {
    load,
    loadGrain,
    fetchDataDetail,
    fetchGrainDataDetail,
    loadLoading,
    loadGrainLoading,
  } = useLoadStore();

  const activeLoad = isCotton ? load : loadGrain;
  const isLoading = isCotton ? loadLoading : loadGrainLoading;

  const fetchData = async () => {
    if (!id) return;
    isCotton ? await fetchDataDetail(id) : await fetchGrainDataDetail(id);
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (isLoading) {
    return <div className="progress-land w-full" />;
  }

  return (
    <div className="w-full py-[24px] px-8 flex flex-col gap-8 relative">
      <div className="flex flex-col w-full">
        <GeneralHeading load={activeLoad} />
      </div>
      {isCotton ? (
        <GeneralData load={load} />
      ) : (
        <GeneralGrainData load={loadGrain} />
      )}

      {activeLoad?.current_status === MeasureType.COMPLETE && (
        <ResidueData load={activeLoad} />
      )}
      {isCotton ? <AnalysisWrapper /> : <AnalysisGrainWrapper />}
    </div>
  );
};
